import { Box, Grid, Typography, List, ListItem, Avatar } from "@mui/material";
import moment from "moment";
import RectangleIcon from "@mui/icons-material/Rectangle";
import React from "react";
import { useNavigate } from "react-router-dom";

interface APITableProps {
    columnFilters: any;
    apis: any[];
    type: "active" | "pending" | "rejected";
}

const APITable: React.FC<APITableProps> = ({ type, apis, columnFilters }) => {
    const [cardHoverIndex, setCardHoverIndex] = React.useState<number | null>(null);
    const navigate = useNavigate();

    const statusColors = {
        active: "#12B76A",
        pending: "#FDB022",
        rejected: "#F04438",
    };

    const statusBgColors = {
        active: "#FFFFFF",
        pending: "#FDB02210",
        rejected: "#F0443810",
    };

    return (
        <List sx={{ bgcolor: "#fafafa" }}>
            <ListItem sx={{ bgcolor: "#f2f2f2", borderRadius: "4px" }}>
                <Box width="100%">
                    <Grid container direction="row" alignItems="center">
                        <Grid item xs={2}>
                            <Typography fontSize="12px">API NAME</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography fontSize="12px">APPLICATION NAME</Typography>
                        </Grid>
                        <Grid item xs={2}>
                            <Typography fontSize="12px">SERVICE NAME</Typography>
                        </Grid>
                        <Grid textAlign="start" item xs={2}>
                            <Typography fontSize="12px">CLOUD PROVIDER</Typography>
                        </Grid>
                        <Grid item textAlign="start" xs={2}>
                            <Typography fontSize="12px">OWNER</Typography>
                        </Grid>
                        <Grid item textAlign="start" xs={2}>
                            <Typography fontSize="12px">REQUESTED ON</Typography>
                        </Grid>
                    </Grid>
                </Box>
            </ListItem>
            {apis.map((api: any, index: number) => (
                <ListItem
                    key={api.id}
                    sx={{
                        border: cardHoverIndex === index ? "1px solid #000" : "1px solid #00000000",
                        mt: 1,
                        bgcolor: statusBgColors[type],
                        borderRadius: "8px",
                        cursor: "pointer",
                    }}
                    onMouseEnter={() => setCardHoverIndex(index)}
                    onMouseLeave={() => setCardHoverIndex(null)}
                    onClick={() => navigate(`/apis/details/${api.id}`)}
                >
                    <Box width="100%">
                        <Grid container direction="row" alignItems="center" justifyContent="space-between">
                            <Grid item xs={2}>
                                {columnFilters.name && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <RectangleIcon sx={{ color: statusColors[type], bgcolor: statusColors[type], width: "4px", marginRight: "8px" }} />
                                        <Typography fontSize="14px" fontFamily="Gilroy-Medium">
                                            {api.name}
                                        </Typography>
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={2}>
                                {columnFilters.applicationName && (
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                        {api.applicationName}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={2}>
                                {columnFilters.serviceName && (
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                        {api.serviceName}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={2}>
                                {columnFilters.cloudProvider && (
                                    <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                        {api.cloudProvider}
                                    </Typography>
                                )}
                            </Grid>
                            <Grid item xs={2}>
                                {columnFilters.solutionOwner && (
                                    <Box sx={{ display: "flex", alignItems: "center" }}>
                                        <Avatar 
                                            src={api.googleProfilePicture} // <-- USE the 'src' prop
                                            sx={{ marginRight: "8px", height: 30, width: 30, bgcolor: 'grey.300' }}
                                        >
                                            {/* This is now a fallback for when there's no image */}
                                            {api.solutionOwner?.charAt(0).toUpperCase()}
                                        </Avatar>
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                            {api.solutionOwner}
                                        </Typography>
                                    </Box>
                                )}
                            </Grid>
                            <Grid item xs={2}>
                                {columnFilters.createdAt && (
                                    <Box display="flex" alignItems="center" justifyContent="space-between">
                                        <Typography fontSize="14px" fontFamily="Gilroy-Regular">
                                            {moment(api.createdAt).format("DD/MM/YYYY | hh:mm A")}
                                        </Typography>
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </ListItem>
            ))}
        </List>
    );
};

export default APITable;